import useSWR from "swr";
import {Utils} from "../common/utils";
const clientConfigs = Utils.getEAIClientConfigs();

export interface FeatureGating {
    school_id: string
    component: string
    name: string
    enabled: boolean
    description: string
    feature_ruuid: string
    settings: unknown
}

export interface FeatureGatingResponse {
    data: FeatureGating[]
}

export function useFeatureGating(schoolId?: string, reset = false) {
    const school = schoolId || clientConfigs.school;
    const {data, error, mutate} = useSWR<FeatureGatingResponse, Error>(
        `${clientConfigs.endpoint}/schools/${school}/features/?reset=${reset}`,
        null,
        {revalidateOnFocus: false});
    return {
        data,
        error,
        mutate
    };
}

export function useFeatureGatingEnabled(component: string, name: string, schoolId?: string, reset = false) {
    const {data, error, mutate} = useFeatureGating(schoolId, reset);
    return {
        enabled: data?.data.some((feature) => feature.component === component && feature.name === name && feature.enabled),
        error,
        mutate
    };
}
